import React from "react";
import { useNavigate } from "react-router";
import EntityLimitsPageBase from "../EntityLimitsPageBase";

const PROFESSIONAL_GUARDIAN_LIMITS_CONFIG = {
  title: "Guardian Limits",
  entityIdParam: "pg_id",
  listPath: (entityId) => `/guardian-limits/guardian/${entityId}/`,
  createPath: () => "/guardian-limits/",
  updatePath: (limitId) => `/guardian-limits/${limitId}/`,
  deletePath: (limitId) => `/guardian-limits/${limitId}/`,
  entityField: "professional_guardian",
  navigateBackOnDelete: true,
  normalizeDates: true,
};

function ProfessionalGuardianLimits() {
  const navigate = useNavigate();

  return (
    <EntityLimitsPageBase
      {...PROFESSIONAL_GUARDIAN_LIMITS_CONFIG}
      onAfterDelete={() => navigate(-1)}
    />
  );
}

export default ProfessionalGuardianLimits;
